export default __webpack_public_path__ + "static/media/arrowRightDark.d35f83b8.svg";